import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { useMemo } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { useConvertSxToEmotionStyles } from '../../hooks/useConvertSxToEmotionStyles.js';
import { useTheme } from '../../hooks/useTheme.js';
import { slugify } from '../../utils/slugHelpers.js';
import { getHeadingTextStyles } from '../../utils/textStyleHelpers.js';
import { b as baseTextComponentSx } from '../shared/shared.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { useGetCurrentSizeClass } from '../../hooks/useGetCurrentSizeClass.js';
import { cloneElementWithCssProp } from '../../utils/componentHelpers.js';

var _excluded = ["size", "weight", "testId", "children", "sx", "rc", "domRef", "autoGenerateId", "id", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HEADING_DEFAULT_STYLES = {
  size: "medium",
  weight: "bold"
};
var DEFAULT_HEADING_COLOR = "base.color.text.heading.primary";
function Heading(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? HEADING_DEFAULT_STYLES.size : _ref$size,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? HEADING_DEFAULT_STYLES.weight : _ref$weight,
    testId = _ref.testId,
    children = _ref.children,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$rc = _ref.rc,
    rc = _ref$rc === void 0 ? jsx("h1", {}) : _ref$rc,
    domRef = _ref.domRef,
    autoGenerateId = _ref.autoGenerateId,
    idProp = _ref.id,
    className = _ref.className,
    headingDomAttributes = _objectWithoutProperties(_ref, _excluded);
  var id = idProp;
  try {
    id = !idProp && autoGenerateId && typeof children === "string" ? slugify(children) : idProp;
  } catch (err) {
    // NOTE: fail silently here, as this is a nice-to-have feature
    // and the id is already set to idProp above
  }
  var themeProps = useTheme();
  var mergedSx = useMemo(function () {
    var _themeProps$component, _themeProps$component2;
    return merge(baseTextComponentSx, {
      c: DEFAULT_HEADING_COLOR
    }, getHeadingTextStyles({
      themeProps: themeProps,
      size: size,
      weight: weight
    }), (_themeProps$component = (_themeProps$component2 = themeProps.components) === null || _themeProps$component2 === void 0 || (_themeProps$component2 = _themeProps$component2.Heading) === null || _themeProps$component2 === void 0 ? void 0 : _themeProps$component2.sxOverride) !== null && _themeProps$component !== void 0 ? _themeProps$component : {}, sx);
  }, [sx, themeProps, size, weight]);
  var css = useConvertSxToEmotionStyles(mergedSx);
  var currentSizeClass = useGetCurrentSizeClass(size, HEADING_DEFAULT_STYLES.size, Object.keys(themeProps.base.text.heading));
  return cloneElementWithCssProp(rc, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, headingDomAttributes), testId ? {
    "data-testid": testId
  } : {}), domRef ? {
    ref: domRef
  } : {}), {}, {
    css: css,
    id: id,
    children: children,
    className: "".concat(className !== null && className !== void 0 ? className : "", " Heading Heading--").concat(currentSizeClass)
  }));
}
Heading.displayName = "Heading";

export { Heading as H };
//# sourceMappingURL=Heading.js.map
